export default __webpack_public_path__ + "static/media/6.bb046934.jpeg";